import { container } from '../../../DataDomain';
import { IMpxRepository } from '../../repositories/interfaces/IMpxRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IGetProductsUseCase {
    execute(feed: string, filters: { [key: string]: string | number | boolean }): Promise<unknown>;
}

export class GetProductsUseCase implements IGetProductsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get mpxRepository(): IMpxRepository {
        return container.resolve<IMpxRepository>(DI.REPOSITORIES.IMpxRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(feed: string, filters: { [key: string]: string | number | boolean }): Promise<unknown> {
        return this.mpxRepository.getProducts(feed, filters);
    }
}
